import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import Navbar from "../components/Navbar";
import Container from "react-bootstrap/esm/Container";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Accordion from "react-bootstrap/Accordion";
import Footer from "../components/footer";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

// SERVICES IMAGES
import kitchen1 from "../assets/images/Kitchen1.jpg";
import kitchen2 from "../assets/images/kitchen2.jpg.webp";


import bathroom1 from "../assets/images/bathroom4.jpg";
import bathroom2 from "../assets/images/bathroomremo3.jpg";
import livingroom1 from "../assets/images/living1.jpg";
import livingroom2 from "../assets/images/living2.jpg";
import tile1 from "../assets/images/tile1.jpg";
import tile2 from "../assets/images/tile2.jpg.avif";
import paint1 from "../assets/images/services/paint2.jpg";




import cabinet1 from "../assets/images/cabinet1.webp";

import cabinet2 from "../assets/images/cabinet2.webp";

import carpet1 from "../assets/images/carpet.jpg";
import carpet2 from "../assets/images/carpet2.webp";

import light1 from "../assets/images/light.jpg";
import light2 from "../assets/images/light2.jpg";
import office1 from "../assets/images/office.jpg";
import office2 from "../assets/images/office2.webp";



import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import image1 from "../assets/images/hero/1.webp";
import image2 from "../assets/images/hero/2.webp";
import image5 from "../assets/images/hero/5.webp";
import bg1 from "../assets/images/hero/bg1.jpg";
import bg2 from "../assets/images/hero/bg2.jpg";
import bg3 from "../assets/images/hero/bg3.jpg.avif";
import bg4 from "../assets/images/hero/bg4.jpg";
import bg5 from "../assets/images/hero/bg5.jpeg";
import bg6 from "../assets/images/hero/bg6.webp";
import bg7 from "../assets/images/hero/bg7.jpg";
import bg8 from "../assets/images/hero/bg8.jpg";
import group from "../assets/images/Group.svg";
import Frame29 from "../assets/images/Frame29.svg";

import amit from "../assets/images/testimonials/amit.png";
import asif from "../assets/images/testimonials/asif.png";
import sarah from "../assets/images/testimonials/sarah.png";
import michael from "../assets/images/testimonials/michael.png";
import linda from "../assets/images/testimonials/linda.png";
import david from "../assets/images/testimonials/david.png";
import jenny from "../assets/images/testimonials/jenny.png";
import james from "../assets/images/testimonials/james.png";

import bf1 from "../assets/images/beforeafter/beforeafter2.webp";
import bf2 from "../assets/images/beforeafter/beforeafter3.webp";

import kitchenRemo from "../assets/images/services/kitchenremo.jpg";
import bathroomRemo from "../assets/images/services/bathroomremo.jpg";
import living from "../assets/images/services/livingremo.jpg";
import tile from "../assets/images/services/tile.jpg";
import carpet from "../assets/images/services/carpet.jpg";
import paint from "../assets/images/services/paint.jpg";


import lighting from "../assets/images/services/lighting.jpg";
import cabinet from "../assets/images/services/cabinet.jpg";
import { QRCodeCanvas } from "qrcode.react";
const heroImages = [
  bg1,
  bg2,
  bg3,
  bg4,
  bg5,
  bg6,
  bg7,
  bg8,
];


const Stars = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const emptyStars = 5 - fullStars;

  return (
    <div style={{ color: "#fbbf24", fontSize: "18px", margin: "8px 0" }}>
      {"★".repeat(fullStars)}
      <span style={{ color: "#e5e7eb" }}>
        {"★".repeat(emptyStars)}
      </span>
    </div>
  );
};

const Home = () => {
  const productsRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToProducts = () =>
    productsRef.current?.scrollIntoView({ behavior: "smooth" });

  const testimonials = [
  {
    name: "Jenny W.",
    role: "Small Business Owner",
    rating: 5,
    text: "Professional, punctual, and high quality work!",
    image: jenny,
  },
  {
    name: "Michael L.",
    role: "Property Manager",
    rating: 4.9,
    text: "Reliable, transparent pricing, and excellent craftsmanship.",
    image: michael,
  },
  {
    name: "Asif K.",
    role: "Homeowner",
    rating: 4.8,
    text: "From start to finish, everything was smooth.",
    image: asif,
  },
];
const sortedTestimonials = [...testimonials].sort(
  (a, b) => b.rating - a.rating
);



  const services = [
  {
    title: "Kitchen Remodeling",
    images: [kitchen1, kitchen2],
  },
  {
    title: "Bathroom Remodeling",
    images: [bathroom1, bathroom2],
  },
  {
    title: "Living Room Design",
    images: [livingroom1, livingroom2],
  },
  {
    title: "Home Office Build",
    images: [office1, office2],
  },
  {
    title: "Tile Installation",
    images: [tile1, tile2],
  },
  {
    title: "Carpet Installation",
    images: [carpet1, carpet2],
  },
  {
    title: "Interior Painting",
    images: [paint, paint1],
  },
  {
    title: "Lighting Upgrade",
    images: [light1, light2],
  },
  {
    title: "Custom Cabinetry",
    images: [cabinet1, cabinet2],
  },
];


  return (
  <div style={{ backgroundColor: "#fff5f7" }}>

      {/* ================= HERO ================= */}
      <section style={{ position: "relative", height: "480px", width: "100%" }}>
        <Swiper
  modules={[Autoplay, Pagination, EffectFade]}
  effect="fade"
  autoplay={{ delay: 3500, disableOnInteraction: false }}
  pagination={{ clickable: true }}
  loop
  style={{ height: "100%" }}
>
  {heroImages.map((img, i) => (
    <SwiperSlide key={i}>
      <img
        src={img}
        alt={`Hero slide ${i + 1}`}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
    </SwiperSlide>
  ))}
</Swiper>

        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
            "linear-gradient(120deg, rgba(0,0,0,0.65), rgba(0,0,0,0.35), rgba(0,0,0,0.65))",

            zIndex: 1,
          }}
        />

        {/* Hero Text */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
            maxWidth: "800px",
            width: "90%",
            zIndex: 2,
          }}
        >
          <div
  style={{
    display: "inline-block",
    padding: "6px 14px",
    borderRadius: "20px",
    background: "rgba(255,255,255,0.15)",
    color: "#fff",
    fontSize: "13px",
    fontWeight: 600,
    marginBottom: "18px",
  }}
>
  Houston’s Trusted Remodeling Experts
</div>

          <h1
  style={{
    fontSize: "3.2rem",
    fontWeight: 800,
    lineHeight: "1.15",
    color: "#ffffff",
    textShadow: "0 8px 30px rgba(0,0,0,0.45)",
    marginBottom: "18px",
  }}
>
  Transforming Homes <br /> Since 1995
</h1>

          <p style={{ margin: "16px 0", color: "#eee" }}>
            Kitchens, bathrooms, flooring, and full-home remodeling — built with precision, honesty, and care.

          </p>
          <button
            onClick={scrollToProducts}
            style={{
              padding: "12px 28px",
              borderRadius: "30px",
              background: "#007bff",
              border: "none",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Get a Free Consultation
          </button>
        </div>
      </section>

      <Navbar />

      {/* ================= SERVICES ================= */}
      <Container className="mt-5" ref={productsRef}>
        <h3 className="text-center mb-4">Our Services</h3>
        <Row>
          {services.map((s, i) => (
            <Col md={4} sm={6} xs={12} key={i} className="mb-4">
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                }}
              >
                <div style={{ display: "flex", gap: "8px" }}>
  {s.images.map((img, idx) => (
    <img
      key={idx}
      src={img}
      alt={s.title}
      style={{
        width: "50%",
        height: "180px",
        objectFit: "cover",
      }}
    />
  ))}
</div>

                <div
  style={{
    padding: "16px",
    textAlign: "center",
  }}
>
  <h6 style={{ margin: 0, fontWeight: 600 }}>
    {s.title}
  </h6>
</div>

              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* ================= TESTIMONIALS ================= */}
      <Container className="mt-5">
        <h3 className="text-center mb-4">What Clients Say</h3>
        <Swiper
  spaceBetween={20}
  pagination={{ clickable: true }}
  style={{ paddingBottom: "40px" }}
  breakpoints={{
    0: {
      slidesPerView: 1,   // phones (Android & iPhone)
    },
    768: {
      slidesPerView: 2,   // tablets
    },
    1024: {
      slidesPerView: 3,   // desktops
    },
  }}
>

  {sortedTestimonials.map((t, i) => (
    <SwiperSlide key={i}>
  <div
    style={{
      background: "#fff",
      borderRadius: "14px",
      padding: "24px",
      minHeight: "120px",
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-8px)";
      e.currentTarget.style.boxShadow =
        "0 14px 30px rgba(0,0,0,0.12)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow =
        "0 6px 18px rgba(0,0,0,0.08)";
    }}
  >
    {/* TOP CONTENT */}
    <div>
      <div
  style={{
    display: "flex",
    justifyContent: "center",
    marginBottom: "14px",
  }}
>
  <img
    src={t.image}
    alt={t.name}
    style={{
      width: "72px",
      height: "72px",
      borderRadius: "50%",
      objectFit: "cover",
      boxShadow: "0 0 0 4px #fde2e8",
    }}
  />
</div>


      <p
        style={{
          fontSize: "15px",
          color: "#555",
          lineHeight: "1.6",
          maxWidth: "280px",
          margin: "0 auto 12px",
        }}
      >
        “{t.text}”
      </p>

      <Stars rating={t.rating} />
    </div>

    {/* BOTTOM CONTENT */}
    <div>
      <h6 style={{ margin: "12px 0 2px", fontWeight: 700 }}>
        {t.name}
      </h6>
      <small style={{ color: "#777" }}>
        {t.role}
      </small>
    </div>
  </div>
</SwiperSlide>

  ))}
</Swiper>

      </Container>
{/* ⭐ LEAVE A REVIEW SECTION */}
<section
  style={{
    background: "#fff5f7",
    padding: "60px 20px",
    textAlign: "center",
  }}
>
  <h3 style={{ fontWeight: 800 }}>Loved Our Work?</h3>

  <p style={{ color: "#555", marginBottom: "24px" }}>
    Scan the QR code or click below to leave us a Google review.
  </p>

  <div
    style={{
      display: "inline-block",
      padding: "18px",
      background: "#ffffff",
      borderRadius: "18px",
      boxShadow: "0 8px 22px rgba(0,0,0,0.1)",
      marginBottom: "20px",
    }}
  >
    <QRCodeCanvas
      value="https://www.google.com/maps/place/Apex+Carpet+%26+Tile/@29.840917,-95.646096,17z/data=!3m1!4b1!4m6!3m5!1s0x8640d9f7e147a8f5:0xc8bd44d032947632!8m2!3d29.840917!4d-95.646096!16s%2Fg%2F1tlvpxw7!18m1!1e1"
      size={160}
    />
  </div>

  <br />

  <a
    href="https://www.google.com/maps/place/Apex+Carpet+%26+Tile/@29.840917,-95.646096,17z/data=!3m1!4b1!4m6!3m5!1s0x8640d9f7e147a8f5:0xc8bd44d032947632!8m2!3d29.840917!4d-95.646096!16s%2Fg%2F1tlvpxw7!18m1!1e1"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "inline-block",
      padding: "12px 30px",
      borderRadius: "30px",
      background: "#2563eb",
      color: "#fff",
      fontWeight: 700,
      textDecoration: "none",
    }}
  >
    ⭐⭐⭐⭐⭐ Leave a Review on Google
  </a>
</section>

{/* ✅ FOOTER MUST COME AFTER */}
<Footer />

</div>
);
};

export default Home;